import React from "react";
import { TableHead } from "@mui/material";
import { HeadroomTableSegment } from "../../utils/headroomTableUtils";
import { AnalysisDriverType } from "../../types/types";
import SkeletonHeader from "./SkeletonHeader";
import HeadroomTableHeaderRow from "./HeadroomTableHeaderRow";
import HeadroomTableSubHeaderRow from "./HeadroomSubheaderTableRow";
import { HeadroomTotals } from "@/graphql/types/graphql";
import HeadroomTableTotalsRow from "./HeadroomTableTotalsRow";

interface HeadroomFinalTableHeaderProps {
  segments: HeadroomTableSegment[];
  driverType: string;
  driverMode: AnalysisDriverType;
  driverNumeratorType: string;
  tableName: string;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  handleSort: (column: string) => void;
  hasOneDataAndOneManualSegment: boolean;
  isSkeleton: boolean;
  totals?: HeadroomTotals;
}

const HeadroomFinalResultsTableHeader: React.FC<HeadroomFinalTableHeaderProps> = ({
  segments,
  driverType,
  driverMode,
  driverNumeratorType,
  tableName,
  sortColumn,
  sortDirection,
  handleSort,
  hasOneDataAndOneManualSegment,
  isSkeleton,
  totals,
}) => {
  const isTwoSameMethod = segments.length === 2 && segments.every((seg) => seg.method === segments[0].method);
  const isManualOnly = segments.length === 1 && segments.every((seg) => seg.method === "MANUAL");
  const isDataOnly = segments.length === 1 && segments.every((seg) => seg.method === "DATA");
  const driver = driverMode === "PERCENTAGE" ? `${driverNumeratorType} as % of ${driverType}` : `${driverType}`;

  const segmentsColSpan =
    segments.length === 0
      ? 2
      : isManualOnly || isDataOnly || hasOneDataAndOneManualSegment
      ? 2
      : isTwoSameMethod
      ? segments.length
      : segments.length * 2;

  if (isSkeleton) {
    const skeletonColumnCount = isManualOnly || isDataOnly || hasOneDataAndOneManualSegment ? 12 : 13;
    return <SkeletonHeader columnCount={skeletonColumnCount} />;
  }

  return (
    <TableHead>
      <HeadroomTableHeaderRow
        segmentsColSpan={segmentsColSpan}
        driverType={driverType}
        driverNumeratorType={driverNumeratorType}
        driverMode={driverMode}
        driver={driver}
      />
      <HeadroomTableSubHeaderRow
        segments={segments}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        handleSort={handleSort}
        hasOneDataAndOneManualSegment={hasOneDataAndOneManualSegment}
        isManualOnly={isManualOnly}
        isDataOnly={isDataOnly}
        isTwoSameMethod={isTwoSameMethod}
        driver={driver}
      />
      <HeadroomTableTotalsRow totals={totals} />
    </TableHead>
  );
};

export default HeadroomFinalResultsTableHeader;
